import React from "react";
import CategoryPage from "./CategoryPage";

const CustomizedWallClocks = () => (
  <CategoryPage
    categoryId="customized-wall-clocks"
    categoryTitle="Customized Wall Clocks"
    categoryDescription="Design your own wall clock with custom graphics, names, or branding. Premium materials, accurate timekeeping, and modern designs. Add personality to any room."
  />
);

export default CustomizedWallClocks;
